import {
    Text,
    View,
    StyleSheet,
} from '@react-pdf/renderer';

import { ReportTimeRangeType } from 'types/Reports';

import { getReportPeriodTypeString } from '../report/utils/reportString';

const filterStyles = StyleSheet.create({
    filterDescription: {
        position: 'relative',
        fontFamily: 'Roboto',
        height: 101,
        marginTop: 15,
        paddingBottom: 15,
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: '#E6E6E6',
    },
    filterDescriptionPeriod: {
        position: 'relative',
        fontFamily: 'Roboto',
        display: 'flex',
        flexDirection: 'row',
    },
    filterDescriptionResourceOn: {
        position: 'relative',
        fontFamily: 'Roboto',
        marginTop: 10,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
    },
    filterDescriptionKey: {
        position: 'relative',
        fontFamily: 'Roboto',
        fontSize: 12,
        fontWeight: 500,
        color: '#636363',
        width: 80,
    },
    filterDescriptionVal: {
        position: 'relative',
        fontFamily: 'Roboto',
        fontSize: 12,
        fontWeight: 500,
        color: '#333333',
        marginLeft: 5,
        width: 480,
        flex: 1,
        maxLines: 3,
    },
    filterDetailsSection: {
        position: 'relative',
        fontFamily: 'Roboto',
        width: 270,
    },
});

type ReportPDFFilterDescriptionProps = {
    reportPeriod: string;
    timeRangeType: ReportTimeRangeType;
    resource: string;
    generatedDate: string;
};

const ReportPDFFilterDescription = ({
    reportPeriod,
    timeRangeType,
    resource,
    generatedDate,
}: ReportPDFFilterDescriptionProps) => {
    const dayIncludeText = getReportPeriodTypeString(timeRangeType);
    const marginTop = resource.length > 163 ? 20 : 10;

    return (
        <View style={filterStyles.filterDescription}>
            <View style={filterStyles.filterDescriptionPeriod}>
                <Text style={filterStyles.filterDescriptionKey}>Report period:</Text>
                <Text style={filterStyles.filterDescriptionVal}>{reportPeriod}</Text>
            </View>
            <View style={filterStyles.filterDescriptionResourceOn}>
                <Text style={filterStyles.filterDescriptionKey}>Days included:</Text>
                <Text style={filterStyles.filterDescriptionVal}>{dayIncludeText}</Text>
            </View>
            <View style={filterStyles.filterDescriptionResourceOn}>
                <Text style={filterStyles.filterDescriptionKey}>Resources:</Text>
                <Text style={filterStyles.filterDescriptionVal} wrap={true}>{resource}</Text>
            </View>
            <View style={{...filterStyles.filterDescriptionResourceOn, marginTop }}>
                <Text style={filterStyles.filterDescriptionKey}>Generated on:</Text>
                <Text style={filterStyles.filterDescriptionVal}>{generatedDate}</Text>
            </View>
        </View>
    );
};

export default ReportPDFFilterDescription;
